import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpService} from '../../core';
import {UserService} from '../../core/services/user.service';
import {environment} from '../../../environments/environment';

/**
 * @class ProfileComponent
 * @memberOf ProfileRoutingModule
 * @description This is a component which control the profile of the system
 */
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {
  personnel: any;
  highestRole: any;
  company: any;
  projects: any;
  SERVER_URL = environment.SERVER_URL;
  constructor(private router: Router, private http: HttpService, private userService: UserService) {


  }
  ngOnInit(): void {
    this.userService.currentUser.subscribe((user: any) => {
      this.highestRole = user.roles[0];
      this.http.getCompanyById(user.company.id).subscribe((res: any) => {
        console.log(res);
        this.company = res.data;
      });

      this.http.searchProjects(user.company.id, '').subscribe((res: any) => {
        console.log(res);
        this.projects = res.data;
      });

      if (this.userService.getCurrentUser().roles[0]?.id !== 4){
        this.userService.getAllUsersByCompanyWithClassification().subscribe((r: any) => {
          this.personnel = r.manager.concat(r.operator);
          console.log(this.personnel);
          this.personnel.map(item => {
            item.email = item.contacts.filter(c => c.contactItem.id === 1)[0].content;
          });
          console.log(this.personnel);

        });
      }
    });
  }

  editCompany() {
    this.router.navigateByUrl('/profile/edit-company');
  }

  editUser() {
    this.router.navigateByUrl('/profile/edit-user');
  }


  encodeURI(url) {
    return encodeURI(url);
  }


}
